import React from 'react';
import './sub2.css'
import { Link } from "react-router-dom";

const Sub2 = () => {
    return (
        <div>

        <div className="country">
            <div className="title">지역별 코스 추천</div>
            <div className="subtitle">완벽한 하루에서 추천하는 코스예요.</div>
        <div className="grid2">
            <div className="bestbox on">
            <a href="#">
            <div className="box1">
              <div className="gridimg1 first">
                <img src="images/gal1.jpg" alt="코스이미지1" />
              <div className="blackbox_3">
                </div>
              </div>
              <div className="con_text2">
                <div className="con_word">강릉편</div>
                <div className="con_subword">강릉에서 바다보며 <br />
                  걷는 데이트코스</div>
                  <div className="con_subword_2">4시 10분 | 3,000원</div>
              </div>
            </div>
          </a>
          
          <a href="#">
            <div className="box2">
              <div className="gridimg2 second">
              <img src="images/gal2.jpg" alt="코스이미지2" />
              <div className="blackbox_3">
                </div>
                </div>
                <div className="con_text2">
              <div className="con_word">강동구편</div>
              <div className="con_subword">강동구에서 분위기 맛집<br />
                데이트를 즐겨보자!</div>
                <div className="con_subword_2">4시 30분 | 25,000원</div>
              </div>
            </div>
          </a>
        
            <a href="#">
            <div className="box3">
              <div className="gridimg3 third">
              <img src="images/gal3.png" alt="코스이미지3" />
              <div className="blackbox_3">
              </div></div>
                <div className="con_text2">
              <div className="con_word">양재편</div>
              <div className="con_subword">양재에서 문화생활<br />
                 즐기는 데이트!</div>
                <div className="con_subword_2">3시 30분 | 47,000원</div>
              </div>
            </div>
          </a>
     
            <a href="#">
            <div className="box4">
              <div className="gridimg4 four">
              <img src="images/gal4.png" alt="코스이미지4" />
              <div className="blackbox_3">
              </div></div>
                <div className="con_text2">
              <div className="con_word">안양편</div>
              <div className="con_subword">걸으면서 느끼는 <br />
                안양의 데이트 코스!</div>
                <div className="con_subword_2">3시간 | 46,400원</div>
              </div>
            </div>
          </a>
        </div>

        <div className="seoul">
          <a href="#">
            <div className="box1">
              <div className="gridimg5 first">
              <img src="images/gal5.jpg" alt="코스이미지5" />
              <div className="blackbox_3">
                </div>
              </div>
              <div className="con_text2">
                <div className="con_word">이태원편</div>
                <div className="con_subword">이태원에서의 <br />
                  감성 넘치는 데이트 코스!</div>
                  <div className="con_subword_2">2시 20분 | 61,000원</div>
              </div>
            </div>
          </a>
           
          <a href="#">
            <div className="box2">
              <div className="gridimg6 second">
              <img src="images/gal6.jpg" alt="코스이미지6" />
              <div className="blackbox_3">
                </div>
                </div>
                <div className="con_text2">
              <div className="con_word">한남동편</div>
              <div className="con_subword">감성 넘치는 <br />
                한남동에서의 데이트 코스!</div>
                <div className="con_subword_2">4시 40분 | 36,800원</div>
              </div>
            </div>
          </a>
         
            <a href="#">
            <div className="box3">
              <div className="gridimg7 third">
              <img src="images/gal7.jpg" alt="코스이미지7" />
              <div className="blackbox_3">
              </div></div>
                <div className="con_text2">
              <div className="con_word">용산편</div>
              <div className="con_subword">용산에서 카페<br />
                 데이트 코스!</div>
                <div className="con_subword_2">2시 30분 | 13,000원</div>
              </div>
            </div>
          </a>

            <a href="#">
            <div className="box4">
              <div className="gridimg8 four">
              <img src="images/gal8.jpg" alt="코스이미지8" />
              <div className="blackbox_3">
              </div></div>
                <div className="con_text2">
              <div className="con_word">시청역편</div>
              <div className="con_subword">시청역에서 <br />
                덕수궁 데이트</div>
                <div className="con_subword_2">2시간 55분 | 23,000원</div>
              </div>
            </div>
          </a>
          </div>
          </div>
          </div>
          <div className="gomain"><Link to="/">메인으로</Link></div>
        </div>
    );
};

export default Sub2;